import { AnalyticQuery } from '@candu-ai/analytics/types';

export function aggregateSeries<T>(query: AnalyticQuery<T>): Record<string, number> {
  const [groupById] = query.fields;
  const lastField = query.fields[query.fields.length - 1];
  const yAxis =
    query.fields.length > 2 ? query.fields.find((f) => f.name === 'count') || lastField : lastField;

  const records: Record<string, number> = {};

  query.rows.forEach((row: any) => {
    const seriesItem = row[groupById.name] as string;
    const value = row[yAxis.name] as number;
    if (!records[seriesItem]) {
      records[seriesItem] = 0;
    }
    records[seriesItem] += value;
  });
  // we need to grab the xAxis for metric (rather than timeseries) to work
  return records;
}
